export default {"src":"/_next/static/media/shipped.b9bb7744.svg","height":512,"width":512};